import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import withWidth from '@material-ui/core/withWidth';

const styles = theme => ({
  root: {
    
  },
  paperFullScreen: {
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.common.white,
      minWidth: 0,
    },
  },
});

function Dialog(props) {
  const {
    children,
    classes,
    className,
    paperClassName,
    width,
    ...otherProps
  } = props;

  return (
    <MuiDialog
      className={classNames(classes.root, className)}
      classes={{
        paper: paperClassName,
        paperFullScreen: classes.paperFullScreen,
      }}
      {...otherProps}
      onEnter={(values) => {
        if (width === 'xs' || width === 'sm') {
          window.scrollTo(0, window.scrollY -1);
        }
        if (otherProps.onEnter) {
          otherProps.onEnter(values);
        }
      }}
      {...width === 'xs' || width === 'sm' ? { fullScreen: true } : {}}
    >
      {children}
    </MuiDialog>
  );
}

Dialog.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

Dialog.defaultProps = {
  className: '',
  paperClassName: '',
};

export default withWidth()(withStyles(styles)(Dialog));



// WEBPACK FOOTER //
// ./src/components/common/Dialog/Dialog.js